<template>
  <div class="card">
    <!--    <div class="card-image">-->
    <!--      <router-link :to="{ path: `/collections/${collection.id}` }">-->
    <!--        <figure class="image is-4by3">-->
    <!--          <img-->
    <!--            src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_3x2.png"-->
    <!--            alt="Placeholder image"-->
    <!--          />-->
    <!--        </figure>-->
    <!--      </router-link>-->
    <!--    </div>-->
    <div class="card-content">
      <div class="content">
        <router-link
          :to="{ path: `/users/${username}/collections?collection=${collection.id}` }"
        >
          <span class="ellipsis is-size-6 has-text-dark-primary"
            ><b-icon size="is-small" icon="earth" />
            {{ collection.attributes.name }}
          </span>
        </router-link>

        <span class="ellipsis is-size-7"
          >{{ collection.attributes.collection_items_count }} Items saved</span
        >

        <b-tooltip
          append-to-body
          type="is-gray"
          :label="`Last update ${dateFromNow(collection.attributes.updated_at)}`"
        >
          <small class="is-italic has-text-gray"
            ><b-icon size="is-small" icon="update"></b-icon
            ><time datetime="2016-1-1">{{
              formatDate(collection.attributes.created_at)
            }}</time></small
          >
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'

export default {
  props: ['collection', 'username'],
  mixins: [dateMixin]
}
</script>
